import React from 'react';
import IconPackage from 'xiv-fanfes-2021';
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import LinkItem from "../../../components/LinkItem/LinkItem";


const SocialMediaNav = ({ list }) => {

  return(
    <SocialMediaNavWrapper>
      {list.map((item,index) => {
        if(item.link !== "")
          return (
          <SNSLink href={item.link} key={`sns_${index}`} type={item.type}>
            <IconPackage.Icon type={item.type} alt={item.alt} />
          </SNSLink>);
        else
          return(<React.Fragment key={`sns_${index}`}></React.Fragment>);
        }
      )}
      
    </SocialMediaNavWrapper>
  );
}

export default SocialMediaNav;


const SocialMediaNavWrapper = styled.div`
  position:relative;
  z-index:2;
  text-align:center;
  font-size:0;
  display:flex;
  margin:0 auto;
  
  justify-content:center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    justify-content:space-between;
    width: 100%;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    flex-wrap:wrap;
    justify-content:center;
  }

`

const SNSLink = styled(LinkItem)`
  display:block;
  width:80px;
  height:80px;
  text-align:center;
  line-height:80px;
  border-radius:40px;
  background: #F7F7FA;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  transition: transform .2s;
  margin: 0 16px;

  svg{
    width:48px;
    height:48px;
    vertical-align: middle;
    color : ${props => {
      switch(props.type)
      {
        case 'Twitter' : return '#1DA1F2';
        case 'Facebook' : return '#1877F2';
        case 'Line' : return '#00C300';
        case 'Instagram' : return '#000000';
        case 'Youtube' : return '#FF0000';
        case 'Twitch' : return '#9146FF';
        default : return '#000000';
      }
    }}
  }

  &:hover{
    transform:scale(1.2);
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:8px;
    width:40px;height:40px;line-height:40px;border-radius:20px;
    svg{
      width:24px;height:24px;
    }
  }
  
`
